import { Link } from "components/Link";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { LinkAdapterProps } from "./Link.d";

const LinkAdapter = ({ blok: { text, href, isInternal } }: ReactStoryblokComponent<LinkAdapterProps>) => (
  <Link text={text} href={href} isExternal={!isInternal} />
);

export default LinkAdapter;
